import type { FaireProductEntity } from "../../entity_types/product";

export const p_x48c83x7w8: FaireProductEntity = {
  token: "p_x48c83x7w8",
  type: "product",
  name: "Short Sleeve Cardigan Lightweight Open Front Knit Sweaters",
  brandToken: "b_t9mynp4xpd",
  brandName: "Lovesoft",
  imageUrl:
    "https://cdn.faire.com/fastly/6a19a2b7c98edf803ad684ba4dfcbf927ca44d85a3541ff290953d0aee35291d.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d44ef713d6584e8d8b37428f90ec5459f413f48b1a24abae082534b549a78f5.webp",
    "https://cdn.faire.com/fastly/a320344ad608771bb7f26ba2b21c4988606f0d67a4cba6252125d999d5fba195.jpeg",
    "https://cdn.faire.com/fastly/8829d181ab499abfce7d557454b837dff14d54731f7153241578e0a36381dbb1.jpeg",
    "https://cdn.faire.com/fastly/064e4e70c67a543d3df5b39bb41b572e1a4332f25f4355edf59b4fd59720ccf0.jpeg",
    "https://cdn.faire.com/fastly/2f78e08d9974551185999f2fa2a5add20a3034f4abd35c2a9bf7b7d33b759d74.jpeg",
    "https://cdn.faire.com/fastly/2077f31ecb96f32fba73af50600a22d054bdddc372ad54889eef603851eb221a.jpeg",
    "https://cdn.faire.com/fastly/e7da57d346f5a411825bc39d4071f4650da643a315e21e5f7a53a1fb42c83561.jpeg",
    "https://cdn.faire.com/fastly/2512ff03e69f4e3572aa3aa4b835def2c789703938d514b37f91779e7e4287f4.jpeg",
    "https://cdn.faire.com/fastly/fe6ad31af590229d04c61b2d5a08a0b357d9f391eeecd4f9ee08ccdaca2ed691.jpeg",
    "https://cdn.faire.com/fastly/4552a3de35fc81272e16fbe156ca701eb9c1811d8806d16cead9015fa736d8b3.jpeg",
    "https://cdn.faire.com/fastly/27eaa80f4611bc541d37a29f84374c9e3b23474de36de56282af2ac84dc1d554.jpeg",
    "https://cdn.faire.com/fastly/9dbde74fbfd35c56142e2a40067bb91215e0b5b7c03a2d8209df05971f5cc191.jpeg",
    "https://cdn.faire.com/fastly/11a2a198029e638a1c710f63550742fe728477a9a7b2a006ce875685f5b478ef.jpeg",
    "https://cdn.faire.com/fastly/35756b45289c5e0cede915380d7a42bb84eef8d483bdb92831d0b96847b1f020.png",
  ],
  priceDollars: 45.85,
  description:
    "Ready to Ship / Expedited Shipping\n* 【Classic & Casual Design】: This women's shrug cardigan sweater with open front and slim fit design, basic and classic design that never goes out of style. The shoulders and sleeves of the womens short sleeve cardigan have knitted hollow designs, allowing you to stay cool in the hot summer. The style of this women's cropped cardigans is simple but stylish, wear it make you look cute, it is an essential fashion item in your wardrobe. \n * 【Occasion】: This womens cropped cardigan has a casual style, perfect for casual, trip, daily, home, travel, vacation, holiday, shopping, street, beach and so on. The womens open front cardigan is also suit for formal occasion, such as work office, schools, party, evening, club, dating, birthday or any other occasions.",
  tags: [],
  msrpDollars: 91.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:09.064Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
